exports.TIERS = {
    ZERO: 'tier0',
    ONE: 'tier1',
    TWO: 'tier2',
    NON: 'tierNon'
};

exports.PA_TIERS_ORDER = [this.TIERS.ZERO, this.TIERS.ONE, this.TIERS.TWO];
exports.TIERS_ORDER = [this.TIERS.ZERO, this.TIERS.ONE, this.TIERS.TWO, this.TIERS.NON];

exports.TIER_TO_NUMBER = {
    [this.TIERS.ZERO]: 0,
    [this.TIERS.ONE]: 1,
    [this.TIERS.TWO]: 2
};

exports.TIER_TO_NAME = {
    [this.TIERS.ZERO]: '0',
    [this.TIERS.ONE]: '1',
    [this.TIERS.TWO]: '2',
    [this.TIERS.NON]: 'na'
};

exports.TIER_DEFAULT_CONFIG = {
    excluded: {
        servers: {}, // {guid: [service1, service2...]}
        ips: {}, // {ip: [service1, service2...]}
        groups: {}, // {guid: [service1, service2...]}
        ous: {}, // {guid: [service1, service2...]}
        conditions: [] // [{conditionType: CONDITIONS_OPTIONS.START_WITH.value, conditionString: 'secret_', services: [service1, service2...]}]
    },
    included: {
        servers: {},
        ips: {},
        groups: {},
        ous: {},
        conditions: []
    }
};

exports.TIER_DEFAULT_STATISTIC = {
    services: [],
    protocols: [],
    total_assets: 0,
    total_assets_include: 0,
    individual_assets: 0,
    security_groups: 0,
    ous: 0,
    dcs: 0,
    ips: 0,
    naming: 0,
    total_services: 0,
    services_list: 0,
    total_assets_exclude: 0,
    individual_assets_exclude: 0,
    security_groups_exclude: 0,
    ous_exclude: 0,
    naming_exclude: 0,
    ips_exclude: 0
};
